export const GET_REPORT = 'GET_REPORT'
export const GET_REPORT_LIST = 'GET_REPORT_LIST'
export const SET_REPORT = 'SET_REPORT'
export const ADD_REPORT = 'ADD_REPORT'
export const FETCH_REPORT = 'FETCH_REPORT'
